import { Injectable } from "@angular/core";
import { UserDto } from "../../api/models/user-dto";
import { UserRole } from "../../server/enums/user-role.enum";

@Injectable({
  providedIn: "root",
})
export class UserRoleService {
  userHasRole(user: UserDto, role: UserRole): boolean {
    return user?.role === role;
  }

  rolesMatch(roles: UserRole[], user: UserDto): boolean {
    return roles?.includes(user?.role as UserRole);
  }

  officeRequired(role: UserRole): boolean {
    return [].includes(role);
  }
}
